<template>
  <div class="goods-release-rule">
    <el-checkbox class="checkbox" v-model="isArrageRule" @change="onChange">
      <span style="color: #333;">发布商品代表您同意</span>
    </el-checkbox>
    <span class="rule" @click.stop="openRule">《胖猫网商品发布规则》</span>
  </div>
</template>

<script>
export default {
  name: 'GoodsReleaseRule',
  props: {
    value: {
      required: true,
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isArrageRule: true
    }
  },
  watch: {
    change: {
      handler(val, oldVal) {
        this.isArrageRule = val
      },
      deep: true
    }
  },
  mounted() {
    this.isArrageRule = this.value
  },
  methods: {
    onChange() {
      this.$emit('input', this.isArrageRule)
    },
    openRule() {
      this.$alert(
        `<div style="margin: 20px 0">
          您正在通过胖猫网平台发布资源并销售货物，请您秉承诚信原则履约，
          按时交货和开具发票，并遵守
          <span @click="toLink" class="rule" onClick="window.open('https://m.pangmao.com/#/tradingRules')">
          《胖猫网平台交易规则》</span>。
          否则，您将承担合同违约责任。同时，胖猫网将视违约情形给予负警告、
          限制交易权限、在平台上进行公告等处理。
        </div>`,
        '胖猫网商品发布规则',
        {
          confirmButtonText: '已阅读并同意',
          dangerouslyUseHTMLString: true,
          center: true,
          callback: action => {}
        }
      )
    }
  }
}
</script>

<style lang="less">
.goods-release-rule {
  .rule,
  label {
    display: inline;
  }
}
.rule {
  color: #f0242e;
  cursor: pointer;
}
</style>
